import ChipMui from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

// `78ch` cap — the character-width unit scales with the user's font size and zoom, whereas
// a px max-width would clip differently across zoom levels.
export const Chip = styled(ChipMui)(({ theme }) => ({
  maxWidth: '78ch',
  transition: theme.transitions.create('background-color', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.short,
  }),
  '&:hover': { backgroundColor: theme.palette.action.hover },
}));
